export default "/_next/static/images/12d4e517c3284df5e0c5347e99b63f8a.jpg";